<!-- 购买云手机支付页面 -->
<template>
  <div :class="$style.wrap">
    <header>
      <p>支付</p>
      <div :class="$style.priceWrap">
        <span :class="$style.price" v-if="!currentCoupon.id">￥{{ (cloudPayInfo.money * cloudPayInfo.num).toFixed(2) }}元</span>
      </div>
      <i :class="[$style.fanhui, 'iconfont', 'yw-guanbi1']" @click="close"></i>
    </header>
    <main>
      <div :class="$style.content">
        <RadioGroup :class="$style.payType" v-model="currentPayType">
          <div v-for="(item, index) in chargeList" :key="index" :class="$style.listItem" @click="checked(item)">
            <div :class="$style.iconItem" :style="`background-color: ${getPayColor(item.img_class_name)}`">
              <img :src="payIcon(item.img_class_name)" />
              <p>{{ item.unite_name }}</p>
              <img v-if="item.recommend === 1" :class="$style.recommend" :src="`${$cdnLink}/wanXin/orangeTheme/tuijian.png`" alt="" />
            </div>
            <Radio :name="item.pay_type" :checked-color="checkedColor" :class="$style.radio"></Radio>
          </div>
        </RadioGroup>
      </div>
      <div :class="$style.btnGroup">
        <Button :class="`${$style.btn} yw-btn yw-btn-primary ${$style.alone}`" @click="toCharge">确认充值</Button>
      </div>
      <p :class="$style.hint" v-if="cloud_hang_up_box_url && cloud_relation_status == 2" @click="redirectBox">前往盒子，查看更多优惠</p>
      <iframe
        id="orderFrame"
        :class="$style.orderFrame"
        name="orderFrame"
        :src="orderIframeLink"
        v-show="orderShow"
        sandbox="allow-scripts allow-same-origin allow-forms allow-top-navigation"
      ></iframe>
    </main>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import { Button, RadioGroup, Radio } from 'vant';
import { checkOrderState, skipWXBox2Sdk } from '@/bridge/AppJsBridge';
import { orderCheck } from '@/api/pay'
import { buryReportV2 } from '@/libs/business/account';
import { wxBoxDownloadUrl } from '@/config'

export default {
  data() {
    return {
      currentPayType: '',
      couponVisible: false, // 是否选中代金券
      currentCoupon: {}, // 当前选中的代金券
      unCouponUse: false,
      hasDefaultCoupon: false,
      checkedColor: '#ff4f4b',
      chargeList: [{
        pay_type: 57,
        unite_name: "支付宝",
        img_class_name: "alipay"
      },{
        pay_type: 26,
        unite_name: "微信",
        img_class_name: "wechat"
      }],
      cloud_relation_status: ''
    };
  },
  mounted() {
    // 重置防重复点击机制
    this.$store.commit('global/CHANGE_STATE', { preventBrush: false });
    if (this.chargeList) this.resetRadio();
    this._clientInit();
    this.cloud_relation_status = this.$getStorage('cloud_relation_status');
  },
  computed: {
    ...mapState({
      tel_status: (state) => state.user.tel_status,
      orderShow: (state) => state.pay.orderShow,
      orderIframeLink: (state) => state.pay.orderIframeLink,
      imgClassName: (state) => state.pay.img_class_name,
      finalPrice: (state) => {
        if (state.pay.order_info.zfAmount) {
          return parseFloat((state.pay.order_info.zfAmount / 100).toFixed(2));
        } else {
          return 0;
        }
      },
      cloud_hang_up_box_url: state => state.suspend.cloud_hang_up_box_url,
      cloud_hang_up_template_id: state => state.suspend.cloud_hang_up_template_id,
      cloud_hang_up_template_name: state => state.suspend.cloud_hang_up_template_name,
      cloudPayInfo: state => state.pay.cloudPayInfo,
    }),
  },
  watch: {
    chargeList(val) {
      if (val.length) {
        this.resetRadio();
      }
    },
  },
  components: {
    Button,
    RadioGroup,
    Radio,
  },
  methods: {
    ...mapActions({
      getPayList: 'voucher/getPayList',
    }),
    close() {
      this.$store.commit('suspend/CHANGE_STATE', { cloudChargeVisible: false });
    },
    checked(e) {
      this.currentPayType = e.pay_type;
      this.$store.commit('pay/CHANGE_STATE', {
        pay_type: e.pay_type,
        img_class_name: e.img_class_name,
        isQrCode: e.isQrCode || false,
      });
    },
    payIcon(type) {
      if (type === 'alipay') return `${this.$cdnLink}/wanXin/orangeTheme/zfb.png`;
      if (type === 'wechat') return `${this.$cdnLink}/wanXin/orangeTheme/weixin.png`;
      if (type === 'huabei') return `${this.$cdnLink}/wanXin/orangeTheme/huabei.png`;
      return require('@/assets/images/pay/visa.png');
    },
    getPayColor(type) {
      if (type === 'wechat') return '#3CB034';
      return '#30B4FF';
    },
    toCharge() {
      buryReportV2('CLOUD_HANG_UP_CONFIRM_IN_PAY', {
        cloud_hang_up_template_id: this.cloud_hang_up_template_id,
        cloud_hang_up_template_name: this.cloud_hang_up_template_name,
        cloud_hang_up_box_url: this.cloud_hang_up_box_url
      });
      this.$store.dispatch('pay/placeCloudOrder', {
        pay_type: this.currentPayType,
      });
    },
    resetRadio() {
      if (this.chargeList.length) {
        this.currentPayType = this.chargeList[0].pay_type;
        this.$store.commit('pay/CHANGE_STATE', {
          pay_type: this.chargeList[0].pay_type,
          img_class_name: this.chargeList[0].img_class_name,
          isQrCode: this.chargeList[0].isQrCode || false,
        });
      }
    },
    _clientInit() {
      checkOrderState(async (data, cb) => {
        if (!this.cloudPayInfo.sy_order_sn) return;
        try {
          const r = await orderCheck({ order_sn: this.cloudPayInfo.sy_order_sn });
          if (r.content.pay_status == 1) {
            this.$toast('支付成功，实际支付结果请以购买记录为准'); 
            if (this.tel_status != 1) {
              this.$store.commit('suspend/CHANGE_STATE', {  
                bindPhoneVisible: true,
                bindHintText: '为防止您的游戏收益受损请绑定手机号以便到期时提醒您'
              })
            }
          } else {
            this.$toast('支付失败，实际支付结果请以购买记录为准'); 
          }
        } catch (error) {
          this.$toast('支付失败，实际支付结果请以购买记录为准');
        }
        this.$store.commit('pay/CHANGE_STATE', {  
          orderShow: false,
          orderIframeLink: '',
          cloudPayInfo: {}
        })
        this.close();
      });
    },
    redirectBox() {
      skipWXBox2Sdk({
        event: 'boxAnyPage',
        syAppkey: "",
        boxUrl: wxBoxDownloadUrl(),
        routePath: '/cloud/CloudMainActivity'
      })
      buryReportV2('CLOUD_HANG_UP_GO_TO_CLICK_PAY', {
        cloud_hang_up_template_id: this.cloud_hang_up_template_id,
        cloud_hang_up_template_name: this.cloud_hang_up_template_name,
        cloud_hang_up_box_url: this.cloud_hang_up_box_url
      });
    },
  },
};
</script>
<style lang="scss" module>
@import '../../../assets/css/common.scss';

.wrap {
  width: 302px;
  height: 250px;
  font-size: 11px;
  background: #ffffff;
  border-radius: 10px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 1000;
  > header {
    position: relative;
    background: url('#{$cdn-url}/wanXin/orangeTheme/payBack.png') no-repeat;
    background-size: 100% 100%;
    color: #ffffff;
    height: 80px;
    padding-top: 10px;
    > p {
      font-size: 16px;
      height: 35px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .fanhui {
      position: absolute;
      top: 8px;
      right: 12px;
      width: 10px;
      height: 10px;
    }
    .priceWrap {
      position: relative;
      height: 20px;
      margin-bottom: 8px;
    }
    .price,
    .couponPrice {
      font-size: 18px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%, -50%, 0);
      font-family: 'PingFang SC', 'Microsoft YaHei', 'Hiragino Sans GB', 'Helvetica Neue', 'Helvetica', 'Arial';
      font-style: normal;
    }
    .couponPrice {
      font-size: 20px;
      text-align: center;
      margin-left: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      .normal {
        text-decoration: line-through;
        font-weight: 400;
        font-size: 14px;
        margin-left: 5px;
      }
    }
    > .voucher {
      background: #ffffff;
      border-radius: 2.5px;
      margin: 5px;
      font-size: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 5px 6px 5px 14px;
      &.noCoupon {
        background: rgba(255, 255, 255, 0.34);
        > span {
          color: #ffffff;
        }
      }
      > span {
        color: $primary-color;
        font-size: 14px;
      }
      .useCoupon {
        border-radius: 1.5px;
        padding: 4px 6px 3px 6px;
        font-size: 11px;
        color: $primary-color;
        &.noCoupon {
          background: #f2f2f2;
          color: #343433;
        }
      }
      .couponContent {
        border-radius: 9px;
        font-size: 11px;
        color: #5f1d10;
        display: flex;
        align-items: center;
        > img {
          width: 14px;
          height: 14px;
          margin-right: 2.5px;
        }
        > span {
          border-radius: 2px;
          padding: 4px 6px 3px 6px;
          background: linear-gradient(90deg, #e9be69, #fbd58d);
        }
      }
    }
    > .couponHint {
      font-size: 9px;
      text-align: center;
      color: #ffffff;
      > img {
        width: 9px;
        height: 9px;
        display: inline-block;
        vertical-align: middle;
      }
      > p {
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
  > main {
    .content {
      padding: 9px 0;
      font-weight: bold;
      text-align: center;
      font-size: 14px;
      .payType {
        overflow-x: auto;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .listItem {
          margin-bottom: 5px;
          padding-bottom: 5px;
          border-bottom: 1px solid #ffffff;
          width: 90px;
          margin: 0 5px;
          .iconItem {
            background: #30b4ff;
            padding: 7px 0;
            text-align: center;
            border-radius: 8px;
            font-size: 12px;
            color: #ffffff;
            position: relative;
            > img {
              width: 25px;
              height: 25px;
              display: inline-block;
              margin-bottom: 2px;
            }
            &:active {
              opacity: 0.8;
            }
            .recommend {
              position: absolute;
              top: 0;
              left: 8px;
              width: 10px;
              height: 20px;
            }
          }
          .radio {
            display: flex;
            justify-content: center;
            margin-top: 5px;
          }
        }
      }
    }
    .btnGroup {
      display: flex;
      justify-content: center;
    }
    .btn {
      background: $btn-background;
      color: #ffffff;
      border: none;
      padding: 0 30px;
      height: 34px;
      line-height: 34px;
      border-radius: 34px;
      font-size: 12px;
      margin: 0 10px;
      &.alone {
        padding: 0 80px;
      }
    }
    .hint {
      font-size: 12px;
      text-decoration: underline;
      color: #0094d9;
      text-align: center;
      margin-top: 8px;
    }
    .submitBtn {
      @include full-screen-button();
    }
    .orderFrame {
      z-index: 999;
      position: fixed;
      width: 100%;
      min-height: 100%;
      text-align: center;
      background: #f4f4f4;
      margin: auto;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      border: 0;
    }
    .payQrCode {
      display: block;
      width: 100px;
      height: 100px;
      margin: 5px auto;
    }
  }
}
</style>
